module.exports = __webpack_public_path__ + "static/media/bandeau.8facb7a9.jpg";